<template>
  <div class="screen-5">
    <div class="container custom-container" id="services">
      <div class="row">
        <div class="col-12 mb-5">
          <TitleWidget class="text-center">{{ $t(locale.s5.title) }}</TitleWidget>
        </div>
        <ServiceListItem v-for="item in listItems" :key="item.id" :item="item"/>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "src/scss/typo";

.screen-5 {
  padding-top: 95px;
  padding-bottom: 0;

  .custom-container {
    @media (min-width: 992px) {
      max-width: 1200px;
    }
  }

  @media (min-width: 576px) {
    padding-top: 140px;
  }
  @media (min-width: 992px) {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .service-first-screen-wrapper {
    @media (min-width: 576px) {
      padding-top: 90px;
    }
  }
}
</style>

<script>
import TitleWidget from "@/components/common/TitleWidget";
import ServiceListItem from "@/components/service/ServiceListItem"
import stringsKeys from "@/i18n/strings.json";

export default {
  name: 'ScreenServices',
  components: {TitleWidget, ServiceListItem},
  data: function () {
    return {
      locale: stringsKeys,
      listItems: [
        {
          id: 'collapseServiceMobile',
          name: stringsKeys.s5.mobile.title,
          icon_file: "icon-mobile.svg",
          separate_spoiler: true,
          visible_text: stringsKeys.s5.mobile.preview,
          spoiler_text: stringsKeys.s5.mobile.text,
          button_text: stringsKeys.s5.mobile.button,
          class_string: ' mt-sm-0 prevent-scroll'
        },
        {
          id: 'collapseServiceWeb',
          name: stringsKeys.s5.web.title,
          icon_file: "icon-web.svg",
          separate_spoiler: true,
          visible_text: stringsKeys.s5.web.preview,
          spoiler_text: stringsKeys.s5.web.text,
          button_text: stringsKeys.s5.web.button,
          class_string: ' mt-sm-0 prevent-scroll'
        },
        {
          id: 'collapseBackEnd',
          name: stringsKeys.s5.server.title,
          icon_file: "icon-backend.svg",
          separate_spoiler: true,
          visible_text: stringsKeys.s5.server.preview,
          spoiler_text: stringsKeys.s5.server.text,
          button_text: stringsKeys.s5.server.button,
          class_string: ' prevent-scroll _open-to-top-768 mt-xl-0 mt-lg-0 open-to-bottom-992 '
        },
        {
          id: 'collapseQa',
          name: stringsKeys.s5.qa.title,
          icon_file: "icon-qa.svg",
          separate_spoiler: true,
          visible_text: stringsKeys.s5.qa.preview,
          spoiler_text: '',
          button_text: stringsKeys.s5.qa.button,
          class_string: ' open-to-top-768 '
        },
        {
          id: 'collapseScale',
          name: stringsKeys.s5.outsource.title,
          icon_file: "icon-scale.svg",
          separate_spoiler: false,
          visible_text: stringsKeys.s5.outsource.preview,
          spoiler_text: '',
          button_text: stringsKeys.s5.outsource.button,
          class_string: ' open-to-top-768 '
        },
        {
          id: 'collapseHR',
          name: stringsKeys.s5.hr.title,
          icon_file: "icon-hr.svg",
          separate_spoiler: true,
          visible_text: stringsKeys.s5.hr.preview,
          spoiler_text: stringsKeys.s5.hr.text,
          button_text: stringsKeys.s5.hr.button,
          class_string: ' open-to-top-768 '
        },
      ]
    }
  }
}
</script>